import script from "./MoleculeTableAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTableAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTableAccordion.vue?vue&type=style&index=0&id=3c109da4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c109da4"]])

export default __exports__